import { lazy } from "react"

export const OrderById = lazy(() => import("./OrderById"))
